import React from "react";
import { ELEMENT_TYPES } from "./ElementPickerItems";


export function ElementPicker({ onSelect }) {
  return (
    <div className="element-picker">
      {ELEMENT_TYPES.map((item) => (
        <button
          key={item.type}
          className="picker-item"
          onClick={() => onSelect(item.type)}
        >
          <span className="picker-icon">{item.icon}</span>
          <span className="picker-label">{item.label}</span>
        </button>
      ))}
      <style>{`.element-picker {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  background: white;
  border: 1px solid #dce3ee;
  padding: 8px;
  border-radius: 6px;
  position: absolute;
  z-index: 99;
  box-shadow: 0px 4px 14px rgba(0,0,0,0.1);
}

.picker-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e6e6e6;
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
}

.picker-item:hover {
  border-color: #1A73E8;
}
`}</style>
    </div>
  );
}
